/**
 * Tone is restricted to the semantic color palette defined in
 * src/styles/global.css (Phase 0 token system) — never an arbitrary
 * string. "positive"/"negative" replace the prior "success"/"danger"
 * naming to align with the directional-color convention used platform-
 * wide (signal direction, P&L sign, win/loss outcome).
 */
export type BadgeTone = "neutral" | "positive" | "negative" | "premium" | "warning" | "info";

interface BadgeProps {
  children: string;
  tone?: BadgeTone;
}

export function Badge({ children, tone = "neutral" }: BadgeProps) {
  return <span className={`badge badge-${tone}`}>{children}</span>;
}
